import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Notification from './Notification';
import Spinner from './Spinner';
import '../styles/Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const navigate = useNavigate();
  const { login, isAuthenticated, loading: authLoading } = useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await login(formData);
      
      if (response.isSignedIn) {
        setNotification({
          show: true,
          message: 'Login successful!',
          type: 'success'
        });
        
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        // Handle cases where additional steps are required (MFA, etc.)
        setNotification({
          show: true,
          message: 'Additional verification required',
          type: 'info'
        });
      }
      
    } catch (error) {
      console.error('Login error:', error);
      setNotification({
        show: true,
        message: error.message || 'Login failed',
        type: 'error'
      });
    } finally {
      setLoading(false);
      setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
    }
  };

  // Show loading spinner while checking authentication state
  if (authLoading) {
    return (
      <div className="auth-container">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
          <Spinner size="large" message="Loading..." />
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      {notification.show && (
        <Notification 
          message={notification.message} 
          type={notification.type} 
        />
      )}
      
      <div className="auth-card">
        <h2>Login</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>
          
          <button 
            type="submit" 
            className="btn-primary auth-btn"
            disabled={loading}
          >
            {loading ? <Spinner size="small" message="" /> : 'Login'}
          </button>
        </form>
        
        <div className="auth-links">
          <p className="auth-link">
            <Link to="/forgot-password">Forgot your password?</Link>
          </p>
          {process.env.REACT_APP_LOGIN_ONLY_MODE !== 'true' && (
            <p className="auth-link">
              Don't have an account? <Link to="/signup">Sign up</Link>
            </p>
          )}
          {process.env.REACT_APP_LOGIN_ONLY_MODE === 'true' && (
            <p className="auth-link" style={{ color: '#666', fontSize: '14px' }}>
              Need access? Contact us for an account.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;